<template>
  <div>
    <div
      class="modal fade"
      id="modal-cargues-masivo"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content shadow position-relative">
          <div v-if="uploading" class="cargando-overlay">
            <div class="cargando-box text-center">
              <div
                class="spinner-border text-light mb-3"
                role="status"
                aria-hidden="true"
              ></div>
              <h5 class="mb-1 text-white font-weight-bold">Cargando...</h5>
              <p class="mb-0 small text-white">
                {{
                  100 > uploadProgress
                    ? "Subiendo archivo (" + uploadProgress + "%)"
                    : "Procesando el archivo de citas"
                }}
              </p>
            </div>
          </div>
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h5 class="modal-title text-white">
              <i class="fas fa-file-excel mr-2"></i>
              Cargues Masivos
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
              :disabled="uploading"
              @click="limpiarModal()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card border-info mb-0">
              <div class="card-header bg-info text-white">
                <h6 class="mb-0">
                  <i class="fas fa-download mr-2"></i>
                  Plantilla Excel
                </h6>
              </div>
              <div class="card-body">
                <p class="text-muted mb-3">
                  Descarga la plantilla y diligencia una fila por cita de
                  <strong>ruta corta</strong>, en este orden: Empresa, Cita
                  Turne fecha y hora, Cita Cargue, Cargue, Turno, Tipo Vehículo,
                  Tipo Producto y Destino. Las fechas deben ir como
                  <code>AAAA-MM-DD HH:MM</code>. La fecha de cita no puede ser
                  anterior a la fecha de turne.
                </p>
                <button
                  type="button"
                  class="btn btn-outline-success btn-sm"
                  @click.prevent="descargarPlantilla"
                  :disabled="descargando"
                >
                  <i class="fas fa-file-excel mr-1"></i>
                  {{
                    descargando ? "Descargando..." : "Descargar Plantilla Excel"
                  }}
                </button>

                <div
                  class="upload-area mt-3"
                  :class="{
                    'drag-over': isDragOver,
                    'has-file': selectedFile,
                  }"
                  @dragover.prevent="handleDragOver"
                  @dragleave.prevent="handleDragLeave"
                  @drop.prevent="handleDrop"
                  @click="triggerFileInput"
                >
                  <div v-if="!selectedFile" class="upload-placeholder">
                    <i
                      class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"
                    ></i>
                    <h5 class="text-muted">Arrastra tu archivo aquí</h5>
                    <p class="text-muted mb-0">o haz clic para seleccionar</p>
                    <small class="text-muted">
                      Formatos soportados: .xlsx, .xls
                    </small>
                  </div>
                  <div v-else class="file-selected">
                    <i class="fas fa-file-excel fa-3x text-success mb-3"></i>
                    <h6 class="text-success">{{ selectedFile.name }}</h6>
                    <p class="text-muted mb-2">
                      Tamaño: {{ formatFileSize(selectedFile.size) }}
                    </p>
                    <button
                      type="button"
                      class="btn btn-outline-danger btn-sm"
                      @click.stop="removeFile"
                    >
                      <i class="fas fa-times mr-1"></i>
                      Eliminar
                    </button>
                  </div>
                </div>

                <input
                  ref="fileInput"
                  type="file"
                  class="d-none"
                  accept=".xlsx,.xls"
                  @change="handleFileSelect"
                />

                <div v-if="uploading" class="mt-3">
                  <div class="progress">
                    <div
                      class="progress-bar progress-bar-striped progress-bar-animated"
                      role="progressbar"
                      :style="{
                        width:
                          (100 > uploadProgress ? uploadProgress : 100) + '%',
                      }"
                    >
                      {{
                        100 > uploadProgress
                          ? uploadProgress + "%"
                          : "Cargando..."
                      }}
                    </div>
                  </div>
                  <small class="text-muted mt-1 d-block">
                    {{
                      100 > uploadProgress
                        ? "Subiendo archivo..."
                        : "Cargando... procesando el archivo"
                    }}
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
              :disabled="uploading"
              @click="limpiarModal()"
            >
              <i class="fas fa-times mr-1"></i>
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              :disabled="!selectedFile || uploading"
              @click="subirArchivo"
            >
              <i class="fas fa-upload mr-1"></i>
              {{ uploading ? "Cargando..." : "Subir Archivo" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "SolicitudCarguesMasivo",
  data() {
    return {
      solicitud: null,
      solicitud_diaria_id: null,
      cargues_ruta_larga: null,
      cargues_ruta_corta: null,
      cargues: null,
      selectedFile: null,
      isDragOver: false,
      uploading: false,
      descargando: false,
      uploadProgress: 0,
    };
  },
  methods: {
    llenarModalImport(
      solicitud,
      cargues_ruta_larga,
      cargues_ruta_corta,
      cargues,
    ) {
      this.solicitud_diaria_id = solicitud.id;
      this.solicitud = solicitud;
      this.cargues_ruta_larga = cargues_ruta_larga;
      this.cargues_ruta_corta = cargues_ruta_corta;
      this.cargues = cargues;
      this.limpiarModal();
    },

    descargarPlantilla() {
      this.descargando = true;
      axios({
        method: "GET",
        url: "/api/hidrocarburos/solicitudes/plantillaCarguesMasivo",
        responseType: "blob",
        params: {
          sitio_id: this.solicitud && this.solicitud.sitio_id,
        },
      })
        .then(async (response) => {
          this.descargando = false;
          const data = response.data;
          const contentType = response.headers["content-type"] || "";

          if (contentType.includes("application/json")) {
            const text = await data.text();
            const json = JSON.parse(text);
            throw new Error(json.message || "No se pudo generar la plantilla");
          }

          const blob = new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          const fileUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = fileUrl;
          link.download = "plantilla_cargues_masivo.xlsx";
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileUrl);
          this.$swal({
            icon: "success",
            title: "Plantilla descargada",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.descargando = false;
          this.$swal({
            icon: "error",
            title: "Ocurrió un error al descargar la plantilla",
            text: e.response?.data?.message || e.message || String(e),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
          });
        });
    },

    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
    },

    handleDragLeave(event) {
      event.preventDefault();
      this.isDragOver = false;
    },

    handleDrop(event) {
      event.preventDefault();
      this.isDragOver = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.validateAndSetFile(files[0]);
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    handleFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.validateAndSetFile(file);
      }
    },

    validateAndSetFile(file) {
      const allowedExtensions = [".xlsx", ".xls"];
      const fileExtension = file.name
        .toLowerCase()
        .substring(file.name.lastIndexOf("."));

      if (!allowedExtensions.includes(fileExtension)) {
        this.$swal({
          icon: "error",
          title: "Formato no válido",
          text: "Solo se permiten archivos Excel (.xlsx, .xls)",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      this.selectedFile = file;
    },

    removeFile() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    async subirArchivo() {
      if (!this.selectedFile) {
        this.$swal({
          icon: "warning",
          title: "Seleccione un archivo Excel",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }

      this.uploading = true;
      this.uploadProgress = 0;
      this.$parent.$parent.cargando = true;

      const formData = new FormData();
      formData.append("file", this.selectedFile);
      formData.append("solicitud_diaria_id", this.solicitud_diaria_id);
      formData.append("fecha", this.solicitud.fecha);
      formData.append("nominacion_id", this.solicitud.nominacion_id);
      formData.append("cargues_ruta_corta", this.cargues_ruta_corta);
      formData.append("cargues_ruta_larga", this.cargues_ruta_larga);
      formData.append("cargues", this.cargues);
      formData.append(
        "solicitudEmpresas",
        JSON.stringify(this.$parent.detSolicitudEmpresas || []),
      );

      try {
        const response = await axios.post(
          "/api/hidrocarburos/solicitudes/importCarguesMasivo",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            },
          },
        );

        const errores = response.data.errores || [];
        let result_content = errores.length
          ? `<div><p class="text-danger"><strong>Los cargues no se cargaron.</strong></p></div>`
          : `<div><p class="text-success"><strong>${response.data.message ||
              "Los cargues se cargaron exitosamente."}</strong></p></div>`;

        if (errores.length) {
          result_content += `<h4>Errores encontrados.</h4>`;
          errores.forEach(
            (err) => (result_content += `<div><small>${err}</small></div>`),
          );
        }

        this.$swal({
          title: "Resultado de la carga",
          html: result_content,
          icon: errores.length ? "error" : "success",
        });

        if (!errores.length) {
          this.$refs.closeModal.click();
          this.limpiarModal();
          const solicitudForm = this.$parent && this.$parent.$parent;
          const solicitud =
            (response.data &&
              (response.data.solicitud || response.data.form)) ||
            null;
          if (solicitudForm && typeof solicitudForm.show === "function") {
            solicitudForm.show();
          } else if (solicitudForm && solicitud) {
            solicitudForm.form = solicitud;
            if (solicitudForm.form.fecha_venci_postulacion != null) {
              const dataFechaVenc = solicitudForm.form.fecha_venci_postulacion.split(
                " ",
              );
              solicitudForm.form.venc_fecha = dataFechaVenc[0];
              solicitudForm.form.venc_hora = dataFechaVenc[1];
            }
          }
          this.$parent.init();
          if (
            solicitudForm &&
            solicitudForm.$refs &&
            solicitudForm.$refs.compSolicitudDiariaCalendar
          ) {
            solicitudForm.$refs.compSolicitudDiariaCalendar.getEvents();
          }
        }
      } catch (e) {
        this.$swal({
          icon: "error",
          title: "Ocurrió un error al subir el archivo",
          text: e.response?.data?.message || String(e),
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          timerProgressBar: true,
        });
      } finally {
        this.uploading = false;
        this.$parent.$parent.cargando = false;
      }
    },

    limpiarModal() {
      this.selectedFile = null;
      this.uploading = false;
      this.descargando = false;
      this.uploadProgress = 0;
      this.isDragOver = false;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
  },
};
</script>

<style scoped>
.upload-area {
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f8f9fa;
  min-height: 180px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-area:hover {
  border-color: #007bff;
  background-color: #e3f2fd;
}

.upload-area.drag-over {
  border-color: #007bff;
  background-color: #e3f2fd;
}

.upload-area.has-file {
  border-color: #28a745;
  background-color: #d4edda;
}

.upload-placeholder,
.file-selected {
  width: 100%;
}

.progress {
  height: 20px;
}

.progress-bar {
  font-size: 12px;
  line-height: 20px;
}

.cargando-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 20;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.3rem;
}

.cargando-box {
  padding: 1.5rem 2rem;
}
</style>
